<template>
    <div class="clear">
        <div class="contentTitle">
            <span class="line" />
            <span style="margin:0 0 20px 10px;color:#009fd9;cursor: pointer" @click="goBack">附件材料上传</span>
            <span style="margin:0 10px">/</span>
            <span>附件详情</span>
        </div>
        <div class="clear">
            <Button @click="downLoadSelect('selection')" type="primary" class="btn-c-common float-r" style="margin-bottom:10px">批量下载</Button>
        </div>
        <Table border ref="selection" :columns="columns" :data="tableData">
            <template slot="fileDate" slot-scope="{ row }">
                <span>{{row.reportYear}}-{{row.reportMonth}}</span>
            </template>
            <template slot="uploadTime" slot-scope="{ row }">
                <span>{{row.uploadTime | getTime('Y')}}</span>
            </template>
            <template slot="action" slot-scope="{ row }">
                <a href="javascript:;" @click="downLoad(row)">下载</a>
            </template>
        </Table>
    </div>

</template>


<script>
import { mapGetters } from "vuex";
import { reportFileDetailService } from "@/api/emissions-report";
import { downloadFileBatch,fileDownloadService } from "@/api/file"
export default {
    data() {
        return {
            columns: [
                { type: 'selection', width: 60, align: 'center' },
                { title: '附件类型', align: 'center', key: 'fileType', width: 260 },
                { title: '月份', align: 'center', slot: 'fileDate' },
                { title: '附件名称', align: 'center', key: 'fileName' },
                { title: '上传时间', align: 'center', slot: 'uploadTime' },
                { title: '操作', align: 'center', slot: 'action' }
            ],
            tableData: []
        }
    },
    computed: {
        ...mapGetters(["getUserInfo"]),
        reportId() {
            return this.getUserInfo.user.reportId;
        },
        fileType() {
            return this.$route.query.fileType;
        }
    },
    created() {
        this.getList()
    },

    methods: {
        getList() {
            let params = {
                reportId: this.reportId,
                fileType: this.fileType
            }
            reportFileDetailService(params).then(res => {
                this.tableData = res.body.fileList;
            })
        },
        downLoad(row){
            if (row.fileName == "") {
                return;
            } else {
                let params = {
                    id: row.id,
                    fileCode: row.fileCode,
                };
                fileDownloadService(params);
            }
        },
        async downLoadSelect(ref) {
            let keys = []
            let selectData = this.$refs[ref].getSelection()

            if (selectData.length === 0) {
                this.$Message.warning('请选择文件')
            } else {
                selectData.forEach(item => {
                    keys.push(item.id)
                })
                let params = {
                    reportId: this.reportId,
                    fileType: this.fileType,
                    fileIds: keys.join()
                }
                await downloadFileBatch(params)
            }
        },
        goBack() {
            this.$router.push({ path: '/material/report3-1' })
        }
    }
}
</script>


<style lang="less" scoped>
.contentTitle {
    margin-bottom: 20px;
    .line {
        border-left: 4px solid #009fd9;
        height: 20px;
    }
}
</style>